import { useNavigate } from "react-router-dom";

const ModifyFormButton = ({eachEventSerieData,type}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (type === "event") {
    navigate(`/${eachEventSerieData.title?.toLowerCase().replace(/\s+/g, "-")}/events-series/${eachEventSerieData.id}/create`, { replace: true });
  }else{
    navigate(`create`);

  }
  };

  return (
    <button
      className="p-4 py-2 px-6 border bg-blue-700 w-full  sm:w-auto"
      onClick={handleClick}
    >
      <svg
        className="w-8 h-7 fill-[#ffffff]"
        viewBox="0 0 448 512"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M448 75.2v361.7c0 24.3-19 43.2-43.2 43.2H43.2C19.3 480 0 461.4 0 436.8V75.2C0 51.1 18.8 32 43.2 32h361.7c24 0 43.1 18.8 43.1 43.2zm-37.3 361.6V75.2c0-3-2.6-5.8-5.8-5.8h-9.3L285.3 144 224 94.1 162.8 144 52.5 69.3h-9.3c-3.2 0-5.8 2.8-5.8 5.8v361.7c0 3 2.6 5.8 5.8 5.8h361.7c3.2.1 5.8-2.7 5.8-5.8zM150.2 186v37H76.7v-37h73.5zm0 74.4v37.3H76.7v-37.3h73.5zm11.1-147.3l54-43.7H96.8l64.5 43.7zm210 72.9v37h-196v-37h196zm0 74.4v37.3h-196v-37.3h196zm-84.6-147.3l64.5-43.7H232.8l53.9 43.7zM371.3 335v37.3h-99.4V335h99.4z"></path>
      </svg>
      Modify Form
    </button>
  );
};

export default ModifyFormButton;
